import React, { useState } from "react";
import { func, bool, string, oneOf } from "prop-types";
import { AnimatePresence } from "framer-motion";

import ArrowUpIcon from "./Icons/ArrowUp";
import ArrowDownIcon from "./Icons/ArrowDown";
import Typography from "./Typography";

import {
  EVENT_ACTION_MORE_INFO,
  EVENT_ACTION_LESS_INFO,
  EVENT_ACTION_DISPLAY,
} from "@gtm/constants";
import { twMerge } from "tailwind-merge";

const EXPANSION_MODES = {
  ABOVE: "above",
  BELOW: "below",
};

const ExpansionPanel = ({
  defaultOpen = false,
  gtmEvent,
  header,
  icon,
  className,
  content,
  dataId,
  expansionMode = EXPANSION_MODES.BELOW,
}) => {
  const [isOpen, setOpen] = useState(defaultOpen);
  const isHeaderString = typeof header === "string";

  const toggleOpen = () => {
    setOpen(!isOpen);
    const eventAction = !isOpen
      ? EVENT_ACTION_MORE_INFO
      : EVENT_ACTION_LESS_INFO;

    gtmEvent(`${EVENT_ACTION_DISPLAY}::${eventAction}`, isOpen);
  };

  const defaultIcon = isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />;
  const toggleIcon = icon ? icon({ isOpen }) : defaultIcon;

  return (
    <div className={twMerge("w-full", className)}>
      <AnimatePresence>
        {isOpen &&
          expansionMode === EXPANSION_MODES.ABOVE &&
          content({ isOpen })}
      </AnimatePresence>
      <div
        className={twMerge(
          "flex items-center relative cursor-pointer",
          isHeaderString && "justify-between"
        )}
        onClick={toggleOpen}
        data-id={dataId}
      >
        {isHeaderString ? (
          <>
            <Typography>{header}</Typography>
            {toggleIcon}
          </>
        ) : (
          header({ icon: toggleIcon, isOpen })
        )}
      </div>
      {/* AnimatePresence is sensor NODE catching unmount and mount of component NEVER place it after conditional */}
      {/* @see https://www.framer.com/api/motion/animate-presence/ */}
      <AnimatePresence>
        {isOpen &&
          expansionMode === EXPANSION_MODES.BELOW &&
          content({ isOpen })}
      </AnimatePresence>
    </div>
  );
};

ExpansionPanel.propTypes = {
  className: string,
  content: func.isRequired,
  dataId: string,
  defaultOpen: bool,
  expansionMode: oneOf(Object.values(EXPANSION_MODES)),
  gtmEvent: func,
  header: func.isRequired,
  icon: func,
};

export default ExpansionPanel;
